import React from 'react';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import S from 'app/features/success/components/Cards.styled';
import Image from 'app/components/Image';
import Text from 'app/components/layout/Text.styled';
import { news } from 'app/features/news/selectors';

const UI = ({ news }) =>
  news.map(({ title, subtitle, url, image }) => (
    <S.News.Card key={url} href={url}>
      <S.News.Card.Thumbnail>
        <S.Card.Image as={Image} src={image} alt={title} />)
      </S.News.Card.Thumbnail>
      <Text as="h4" size="l" type="semibold" isFixedSize>
        {title}
      </Text>
      <Text as={S.Card.Subtitle} size="m">
        {subtitle}
      </Text>
    </S.News.Card>
  ));

UI.propTypes = {
  news: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      url: PropTypes.string,
      image: PropTypes.string,
    }),
  ).isRequired,
};

UI.displayName = 'LatestNews';

const LatestNews = connect({ news })(UI);

export { UI };

export default LatestNews;
